<template>
<div>
    <!-- <h1>{{ $t("inviteSponsorView.sendInvitation") }}</h1> -->
    <h2>{{ $t("inviteSponsorView.viaEmail") }}</h2>
    <form @submit.prevent="inviteViaEmail()" class="field">
        <input v-for="(s, i) in sponsors" type="email" v-model="s.email" :placeholder="$t('inviteSponsorView.writeEmailAddress')" :key="i" />
        <div>
            <div class="borderless-button" @click="addRecipient()">
                {{ $t("inviteSponsorView.addRecipient") }}
            </div>
        </div>
        <div>
            <button type="submit" :disabled="!isValidatedForSubmit" class="button button-green">{{ $t("inviteSponsorView.sendInvitations") }}</button>
        </div>
    </form>

    <div v-if="status == 'Sending'">
        {{ $t("inviteSponsorView.sendingInvitations ") }}
        <kk-spinner />
    </div>

    <div v-else-if="status == 'Sent'">
        {{ $t("inviteSponsorView.emailInvitationsSent") }}
    </div>

    <div class="section">
        <div>
            <button v-if="!sponsorCopied" type="button" class="button" @click="copySponsorLink()">
                {{ $t("inviteSponsorView.copySponsorLink") }}
                <input ref="text" type="text" v-model="sponsorlink" style="font-size:.7em" />
            </button>
                <button v-else type="button" class="button button-primary">
                {{ $t("inviteSponsorView.copied") }}
            </button>
        </div>
        <div>
            <button class="button" @click="invitePreviousSponsors">
                {{ $t("inviteSponsorView.invitePreviousSponsors") }}
            </button>
        </div>
    </div>

</div>
</template>

<script lang="ts">
import { store, Sponsor, SponsorType } from "store";
import axios from "axios";
import { defineComponent } from "vue";

type SendStatus = "Sending" | "Sent";

export default defineComponent({
    async mounted() {
        this.setTitle();
        this.sponsorlink = (await axios.get<string>("sponsors/joinlink/" + store.selectedEvent.eventParticipant.eventParticipantId)).data;
    },
    data() {
        const sponsors: Sponsor[] = [ this.createEmptySponsor() ];
        const error: string = null;
        const status: SendStatus = null;

        return {
            status,
            error,
            store: store,
            sponsors,
            sponsorlink: "",
            sponsorCopied: false
        };
    },
    computed: {
        isValidatedForSubmit() {
            return this.sponsors.some(s => !!s.email);
        }
    },
    methods: {
        setTitle() {
            store.page.title = this.$t("inviteSponsorView.title") as string;
            store.page.showTopNav = true;
        },
        addRecipient() {
            this.sponsors.push(this.createEmptySponsor());
        },
        async inviteViaEmail() {
            this.status = "Sending";
            try {
                let invitedSponsors = [];
                invitedSponsors = this.sponsors
                    .map(s => ({
                        ...s,
                        email: s.email.trim(),
                        invitedOn: new Date(Date.now())
                     }))
                     .filter(s => s.email);

                let emails = invitedSponsors.map(s => s.email);
                let result = (await axios.post("sponsors/invite-email", { eventId: this.store.selectedEvent.eventId, emails })).data;
                this.status = "Sent";
                this.$set(store.selectedEvent, "sponsors", store.selectedEvent.sponsors.concat(invitedSponsors));
                this.sponsors = [ this.createEmptySponsor() ];
            } catch {
                this.error = this.$t("inviteSponsorView.emailInvitationFailed") as string;
            }
        },
        createEmptySponsor(email = ""): Sponsor {
            return {
                sponsorId: 0,
                firstname: "",
                lastname: "",
                fullName: "",
                sponsorType: "Private",
                companyName: null,
                email: email,
                payment: 0,
                notificationSentOn: null,
                numNotificationsSent: 0,
                participationStatus: "NotAnswered",
                shouldPay: null,
                paid: 0,
                estimatedPayment: null,
                paymentMethod: "Manual",
                billSentOn: null,
                eventParticipantId: 0,
                streetAddress: "",
                zipCode: "",
                city: "",
                sendingEmail: false,
                editingEmail: false,
                info: null,
                preferredBillingMethod: "Email",
            };
        },
        isDuplicateEmail(email): boolean {
            return store.selectedEvent.sponsors.find(s => s.email === email) != null;
        },
        invitePreviousSponsors() {
            this.$router.push('/invite-previous-sponsors');
        },
        copySponsorLink() {
            (this.$refs.text as any).select();
            document.execCommand('copy');

            this.sponsorCopied = true;

            setTimeout(() => {
                this.sponsorCopied = false
            }, 2000);
        }
    }
})

</script>